export default __webpack_public_path__ + "static/brand-moments-77dcce0997d3c9d7130e08de8263880bef350a24a8d4aea7a46f8b49c5a6e33d.png";